import { useRef } from "react";

import { MamaMarkdown } from "./mama-markdown";
import { cn } from "~/util/cn";

export const MarkdownTextStream: React.FC<{
  rawMarkdown: string;
  className?: string;
  onComplete?: () => void;
}> = ({ rawMarkdown, className, onComplete }) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div ref={ref} className={cn("overflow-hidden", className)}>
      <MamaMarkdown text={rawMarkdown} stream onComplete={onComplete} />
    </div>
  );
};
